import React from 'react';
import AniLink from "gatsby-plugin-transition-link/AniLink"

const PrimaryNavLink = ({ label, link, image, altText, id }) => {
  return (
    <AniLink id={id || ''} className='primary-link' fade to={link}><div className='icon-wrapper'>{image && <img src={image} alt={altText} />}</div>{label}</AniLink>
  )
}

export default PrimaryNavLink;
